import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoOrganizerAction, 
  setIsFetching, 
  setFetchFailed, 
  setContent,
} from 'Pages/InfoOrganizerPage/Redux/actions';

export const fetchOrganizerContent = () => {
  return async (dispatch: Dispatch<InfoOrganizerAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoOrganizer;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('OrganizerPage');

      if (response.status !== 200) {
        dispatch(setFetchFailed());
      } else {
        const newContent: Julius.Website.OrganizerPageViewModel = await response.json();
        dispatch(setContent(newContent));
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/pages/InfoOrganizerPage/Redux/thunks.tsx